import { cn } from "@/lib/cn";
import type { HTMLAttributes, ReactNode } from "react";

type Elevation = "flat" | "raised" | "floating";

const elevations: Record<Elevation, string> = {
  flat: "shadow-none",
  raised: "shadow-warm-sm",
  floating: "shadow-warm",
};

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  elevation?: Elevation;
  /** Sin padding interno cuando el contenido maneja su propio espaciado. */
  bare?: boolean;
  children?: ReactNode;
}

export function Card({
  elevation = "raised",
  bare = false,
  className,
  children,
  ...props
}: CardProps) {
  return (
    <div
      className={cn(
        "rounded-[var(--radius-app)] bg-surface border border-sand-200",
        elevations[elevation],
        !bare && "p-4 sm:p-5",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardTitle({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3
      className={cn("font-display text-lg text-ink", className)}
      {...props}
    >
      {children}
    </h3>
  );
}

export function CardBody({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("text-sm text-ink-soft", className)} {...props}>
      {children}
    </div>
  );
}
